module.exports = __webpack_public_path__ + "img/icon_policy.57c81893.png";